import { render, staticRenderFns } from "./TradeInListTable.vue?vue&type=template&id=89ce1c54&scoped=true"
import script from "./TradeInListTable.vue?vue&type=script&lang=js"
export * from "./TradeInListTable.vue?vue&type=script&lang=js"
import style0 from "./TradeInListTable.vue?vue&type=style&index=0&id=89ce1c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ce1c54",
  null
  
)

export default component.exports